export enum MasteryStatus {
  Mastered = 'mastered',
  NotMastered = 'not mastered',
  NotEvaluated = 'not evaluated',
  NotCovered = 'not covered',
  NotProficient = 'not proficient',
  Proficient = 'proficient',
  NotFullyMastered = 'not fully mastered'
}
